<template>
    <v-btn text @click.stop="openCourseCreateDialog">Создать курс</v-btn>
</template>

<script>
    import {BUS} from "~/plugins/bus";

    export default {
        name: "CourseAction",
        methods: {
            openCourseCreateDialog() {
                BUS.$emit('openCourseCreateDialog')
            }
        }
    }
</script>

<style scoped>

</style>